/**
 * Formats a chat message timestamp for display next to the sender name.
 *
 * - If the message was sent today, the time is shown (e.g. "09:41 AM").
 * - If the message was sent yesterday or earlier, the day is shown instead
 *   (e.g. "Jun 26").
 *
 * Returns an empty string when no timestamp is available.
 */
export function formatChatMessageTimestamp(date: Date | string | undefined | null): string {
  if (!date) return '';

  const messageDate = new Date(date);
  if (isNaN(messageDate.getTime())) return '';

  return isSameDay(messageDate, new Date()) ? formatTimeOfDay(messageDate) : formatMonthAndDay(messageDate);
}

function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

function formatTimeOfDay(date: Date): string {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function formatMonthAndDay(date: Date): string {
  return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
}
